<div *ngIf="switchAccountOptions" class="switch-account-options" (clickOutside)="switchAccountOptions = false">
  <ng-container *ngIf="this?.customers?.length > 0; else noCustomers" class="wrapper">
    <div class="title">
      <p class="bold">{{ 'navigation.switch' | translate }}</p>
    </div>
    <div class="line"></div>

    <!-- 🔍 Search with Clear Icon -->
    <div class="search-customer relative" *ngIf="customers?.length > 4">
      <input
        type="text"
        class="form-control placeholder:text-sm pr-8 w-full"
        [formControl]="searchForm.get('searchCustomer')"
        [placeholder]="'navigation.search_customer' | translate"
      />
      <button
        *ngIf="searchForm.get('searchCustomer')?.value"
        type="button"
        (click)="clearSearch()"
        class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 focus:outline-none"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
          stroke="currentColor" stroke-width="2" class="w-5 h-5">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <div class="line" *ngIf="customers?.length > 4"></div>

    <!-- Customer List -->
    <div *ngIf="filteredCustomers?.length > 0; else noResults">
      <div
        class="d-flex justify-content-between item"
        *ngFor="let customer of filteredCustomers"
        (click)="!isCurrentCompany(customer) && onSwitchCustomer(customer)"
        [ngClass]="{ 'disabled-company': isCurrentCompany(customer) }"
      >
        <p class="mt-auto mb-auto">{{ customer?.companyName | titlecase }}</p>
        <img
          class="mt-auto mb-auto"
          [src]="isCurrentCompany(customer)
            ? '/assets/img/checked.svg'
            : '/assets/img/Arrow-right.svg'"
          [alt]="isCurrentCompany(customer) ? 'Selected' : 'Select'"
          loading="lazy"
        />
      </div>
    </div>

    <ng-template #noResults>
      <div class="text-center text-muted mt-1 font-bold">
        {{ 'navigation.search_not_found' | translate }}
      </div>
    </ng-template>
  </ng-container>

  <ng-template #noCustomers>
    <div class="title">
      <p class="bold">{{ 'navigation.no-companies-to-select' | translate }}</p>
    </div>
  </ng-template>
</div>
